module.exports = "/_next/static/images/36e35ce48e9ff73a34ec8b9d044c35e6-card-and-phone-3d-lg@1x.jpg";